import {
	Stack,
	SxProps,
	useTheme,
	Switch as MuiSwitch,
	SwitchProps,
	Typography,
} from '@mui/material';
import { styled } from 'styled-components';

import { Dimens } from '~themes';

interface Props {
	isOn: boolean;
	onToggled: (newState: boolean) => void;
	title?: string;
	subtitle?: string;
	isDisabled?: boolean;
	sx?: SxProps;
}

const Switch = ({ isOn, onToggled, title, subtitle, isDisabled = false, sx }: Props) => {
	const { palette } = useTheme();
	return (
		<Stack direction='row' alignItems={'center'} sx={sx} gap={Dimens.spacingLg}>
			<Stack direction='column' sx={{ flex: 1 }}>
				{title && (
					<Typography variant='label' color={palette.textPrimary.main}>
						{title}
					</Typography>
				)}
				{subtitle && (
					<Typography variant='labelSm' color={palette.textQuaternary.main}>
						{subtitle}
					</Typography>
				)}
			</Stack>
			<IOSSwitch
				checked={isOn}
				onChange={(event) => onToggled(event.target.checked)}
				disabled={isDisabled}
			/>
		</Stack>
	);
};

export default Switch;

// Copied and modified from MUI example.
const IOSSwitch = styled((props: SwitchProps) => (
	<MuiSwitch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(({ theme: _theme }) => {
	const { palette, transitions } = useTheme();
	const width = 36;
	const height = 20;
	return {
		width: width,
		height: height,
		padding: 0,
		'& .MuiSwitch-switchBase': {
			padding: 0,
			margin: 2,
			transitionDuration: '300ms',
			'&.Mui-checked': {
				transform: 'translateX(16px)',
				color: '#fff',
				'& + .MuiSwitch-track': {
					backgroundColor: palette.bgSuccessSolid.main,
					opacity: 1,
					border: 0,
				},
				'&.Mui-disabled + .MuiSwitch-track': {
					opacity: 0.5,
				},
			},
			'&.Mui-disabled .MuiSwitch-thumb': {
				color: palette.fgDisabled.main,
			},
			'&.Mui-disabled + .MuiSwitch-track': {
				opacity: 0.7,
			},
		},
		'& .MuiSwitch-thumb': {
			boxSizing: 'border-box',
			width: height - 4,
			height: height - 4,
		},
		'& .MuiSwitch-track': {
			borderRadius: height / 2,
			backgroundColor: palette.bgTertiary.main,
			opacity: 1,
			transition: transitions.create(['background-color'], {
				duration: 500,
			}),
		},
	};
});
